import React from 'react';

const articleTypeConfig = {
  'original-research': {
    label: 'Original Research',
    className: 'bg-blue-100 text-blue-800 border border-blue-200',
  },
  review: {
    label: 'Review',
    className: 'bg-purple-100 text-purple-800 border border-purple-200',
  },
  'case-report': {
    label: 'Case Report/Series',
    className: 'bg-green-100 text-green-800 border border-green-200',
  },
  letter: {
    label: 'Letter',
    className: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
  },
  commentary: {
    label: 'Commentary',
    className: 'bg-orange-100 text-orange-800 border border-orange-200',
  },
  'systematic-review-meta-analysis': {
    label: 'Systematic Review & Meta-analysis',
    className: 'bg-indigo-100 text-indigo-800 border border-indigo-200',
  },
  edge: {
    label: 'EDGE',
    className: 'bg-teal-100 text-teal-800 border border-teal-200',
  },
  others: {
    label: 'Others',
    className: 'bg-gray-100 text-gray-800 border border-gray-200',
  },
  // 'open-access': {
  //   label: 'Open Access',
  //   className: 'bg-amber-tint text-amber-tinttext border border-amber',
  // },
};

function typeToKey(type) {
  if (!type) return null;
  const lower = type.toLowerCase();
  if (lower === 'original research') return 'original-research';
  if (lower === 'review') return 'review';
  if (lower === 'case report') return 'case-report';
  if (lower === 'letter') return 'letter';
  if (lower === 'commentary') return 'commentary';
  return lower.replace(/\s+/g, '-');
}

function Badge({ type, openAccess = false, className = '' }) {
  // if (openAccess) {
  //   const config = articleTypeConfig['open-access'];
  //   return (
  //     <span
  //       className={`inline-flex items-center gap-1 text-xs font-sans font-semibold px-2 py-0.5 rounded-full ${config.className} ${className}`}
  //     >
  //       <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
  //         <path
  //           fillRule="evenodd"
  //           d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
  //           clipRule="evenodd"
  //         />
  //       </svg>
  //       Open Access
  //     </span>
  //   );
  // }

  const key = typeToKey(type);
  const config = articleTypeConfig[key] || {
    label: type || 'Article',
    className: 'bg-bg-tag text-slate border border-bg-border',
  };

  return (
    <span
      className={`inline-block text-xs font-sans font-semibold px-2 py-0.5 rounded-full ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}

export default Badge;
